export const LibraryPostType =
{
    File: 1,
    Url: 2,
}

export const LibraryClassificationType =
{
    Public: 1,
    VisaConfidential: 2,
    Subscription: 3,
    Store: 4,
    VisaInternalProcess: 5
}